export const isOpenSelector = ({ ConfirmationModal: { openConfirmations } }, { id }) =>
  openConfirmations.findIndex(confirmationID => confirmationID === id) !== -1;

export default isOpenSelector;
